import { useEffect, useState } from 'react';

/**
 * Lightweight UI prefs for the dashboard shell: a persisted dark-mode toggle and
 * a tiny i18n helper for the nav/chrome (graceful fallback to English).
 */

// ── Dark mode ──
export function useDarkMode(): [boolean, () => void] {
  const [dark, setDark] = useState<boolean>(() => {
    try { return localStorage.getItem('theme') === 'dark'; } catch { return false; }
  });
  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add('dark'); else root.classList.remove('dark');
    try { localStorage.setItem('theme', dark ? 'dark' : 'light'); } catch { /* ignore */ }
  }, [dark]);
  return [dark, () => setDark((d) => !d)];
}

// ── i18n (chrome only) ──
const NAV: Record<string, Record<string, string>> = {
  en: { Dashboard: 'Dashboard', Users: 'Users', Organizations: 'Organizations', 'Roles & Permissions': 'Roles & Permissions', 'Audit Logs': 'Audit Logs', Webhooks: 'Webhooks', 'API Keys': 'API Keys', 'Email Templates': 'Email Templates', Settings: 'Settings', 'Sign out': 'Sign out' },
  es: { Dashboard: 'Panel', Users: 'Usuarios', Organizations: 'Organizaciones', 'Roles & Permissions': 'Roles y permisos', 'Audit Logs': 'Auditoría', Webhooks: 'Webhooks', 'API Keys': 'Claves API', 'Email Templates': 'Plantillas de correo', Settings: 'Ajustes', 'Sign out': 'Cerrar sesión' },
  fr: { Dashboard: 'Tableau de bord', Users: 'Utilisateurs', Organizations: 'Organisations', 'Roles & Permissions': 'Rôles et permissions', 'Audit Logs': 'Journaux', Webhooks: 'Webhooks', 'API Keys': 'Clés API', 'Email Templates': 'Modèles d\'e-mail', Settings: 'Paramètres', 'Sign out': 'Se déconnecter' },
};

export function getLocale(): string {
  try { return localStorage.getItem('locale') || 'en'; } catch { return 'en'; }
}
export function setLocale(loc: string) {
  try { localStorage.setItem('locale', loc); } catch { /* ignore */ }
  window.location.reload();
}
export function useChromeT() {
  const loc = getLocale();
  return (s: string): string => NAV[loc]?.[s] ?? s;
}
